module.exports = __webpack_public_path__ + "media/images/icons/chevron-39af5f297367efab5362245a57c0afd6.svg";